import type { SVGProps } from 'react'
const SvgSyNfc = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M5.135 7.416a.6.6 0 0 0-.453.074.6.6 0 0 0-.192.828l5 8a.6.6 0 0 0 .828.192.6.6 0 0 0 .192-.828l-5-8a.6.6 0 0 0-.375-.266" />
		<path
			fillOpacity={0.24}
			d="M18.877 2.92a.6.6 0 0 0-.455.06.6.6 0 0 0-.219.82 16.4 16.4 0 0 1 0 16.4.6.6 0 0 0 .219.82.6.6 0 0 0 .82-.22 17.6 17.6 0 0 0 0-17.6.6.6 0 0 0-.365-.28m-4.33 2.5a.6.6 0 0 0-.455.06.6.6 0 0 0-.219.82 11.4 11.4 0 0 1 0 11.4.6.6 0 0 0 .219.82.6.6 0 0 0 .82-.22 12.6 12.6 0 0 0 0-12.6.6.6 0 0 0-.365-.28"
		/>
		<path d="M10.084 7.42a.6.6 0 0 0-.455.06.6.6 0 0 0-.22.82 7.4 7.4 0 0 1 0 7.4.6.6 0 0 0 .22.82.6.6 0 0 0 .818-.22 8.6 8.6 0 0 0 0-8.6.6.6 0 0 0-.363-.28m-5.168 0a.6.6 0 0 0-.363.28 8.6 8.6 0 0 0 0 8.6.6.6 0 0 0 .818.22.6.6 0 0 0 .22-.82 7.4 7.4 0 0 1 0-7.4.6.6 0 0 0-.22-.82.6.6 0 0 0-.455-.06" />
	</svg>
)
export default SvgSyNfc
